import { intl } from 'src/i18n/createIntl';

export default function validatePassword(password: string, ): string | null {
  if (!password) {
    return intl().formatMessage({ id: 'MursionPortal.ErrorMessage.PasswordCannotBeEmpty' });
  }

  return null;
}
